var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 32.5,
    fill: "#B8EBF5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7.5,
    width: 51,
    height: 51,
    rx: 25.5,
    stroke: "#FAFAFA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.64 29.768C36.64 31.0053 36.3627 32.0187 35.808 32.808C35.2747 33.576 34.4853 34.1093 33.44 34.408V34.472C34.7627 34.5787 35.7547 35.0373 36.416 35.848C37.0987 36.6587 37.44 37.8107 37.44 39.304C37.44 41.2453 36.8533 42.728 35.68 43.752C34.528 44.776 32.8533 45.288 30.656 45.288C29.3973 45.288 28.2667 45.224 27.264 45.096C26.2827 44.9893 25.5147 44.8293 24.96 44.616V41.288C25.7493 41.4587 26.528 41.5867 27.296 41.672C28.0853 41.736 28.992 41.768 30.016 41.768C31.36 41.768 32.3307 41.5547 32.928 41.128C33.5467 40.68 33.856 39.9653 33.856 38.984C33.856 38.0667 33.5893 37.3947 33.056 36.968C32.5227 36.5413 31.6907 36.328 30.56 36.328H27.2V33.096H29.856C30.9013 33.096 31.6907 32.8827 32.224 32.456C32.7787 32.008 33.056 31.3467 33.056 30.472C33.056 29.576 32.832 28.9467 32.384 28.584C31.936 28.2 31.2 28.008 30.176 28.008C29.472 28.008 28.5653 28.0827 27.456 28.232C26.368 28.36 25.7067 28.4667 25.472 28.552V25.384C26.1333 25.1707 26.9973 24.9893 28.064 24.84C29.152 24.6907 30.2187 24.616 31.264 24.616C33.0347 24.616 34.368 25.0533 35.264 25.928C36.1813 26.8027 36.64 28.0827 36.64 29.768Z",
    fill: "#0B4F5D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC3);
export default __webpack_public_path__ + "static/media/C3.f419ac2255f51eb4325428a1560166b8.svg";
export { ForwardRef as ReactComponent };